const types = {
  OPEN_OUTBOUND: 'OPEN_OUTBOUND',
  CLOSE_OUTBOUND: 'CLOSE_OUTBOUND',
  TOGGLE_MINIMIZE_OUTBOUND: 'TOGGLE_MINIMIZE_OUTBOUND',
  TOGGLE_MAXIMIZE_OUTBOUND: 'TOGGLE_MAXIMIZE_OUTBOUND',
  SET_CURRENT_DATA_OUTBOUND: 'SET_CURRENT_DATA_OUTBOUND'
}

export default types
